module.exports = __webpack_public_path__ + "static/media/mh.9a89d81f.webp";